module.exports = __webpack_public_path__ + "img/icon15.42bc138a.png";